// HSCIS — konstanta statis yang dipakai di seluruh frontend.
// Import dari sini, BUKAN dari mock/data.js

// ── Role identifiers (harus cocok dengan nilai di backend) ──────────────────
export const ROLES = {
  MAIN_DEALER: "main_dealer",
  KEPALA_CABANG: "kepala_cabang",
  TEAM_LEADER: "team_leader",
  SALES: "sales",
};

// Label tampilan untuk setiap role
export const ROLE_LABELS = {
  main_dealer: "Main Dealer",
  kepala_cabang: "Kepala Cabang",
  team_leader: "Team Leader",
  sales: "Sales",
};

// ── Status prospek ───────────────────────────────────────────────────────────
export const PROSPECT_STATUS = {
  new: { label: "New", color: "#22C55E", bg: "#DCFCE7" },
  follow_up: { label: "Follow Up", color: "#EAB308", bg: "#FEF9C3" },
  hot: { label: "Hot", color: "#F97316", bg: "#FFEDD5" },
  closing: { label: "Closing", color: "#3B82F6", bg: "#DBEAFE" },
  lost: { label: "Lost", color: "#EF4444", bg: "#FEE2E2" },
};

// ── Tipe produk Honda Babel ──────────────────────────────────────────────────
export const PRODUCT_TYPES = [
  { id: "BEAT", name: "Honda BeAT", category: "Matic Entry", price: 18_500_000 },
  { id: "GENIO", name: "Honda Genio", category: "Matic Entry", price: 19_200_000 },
  { id: "SCOOPY", name: "Honda Scoopy", category: "Matic Stylish", price: 22_400_000 },
  { id: "VARIO125", name: "Honda Vario 125", category: "Matic Sporty", price: 24_600_000 },
  { id: "VARIO160", name: "Honda Vario 160", category: "Matic Sporty", price: 28_950_000 },
  { id: "PCX160", name: "Honda PCX 160", category: "Matic Premium", price: 33_750_000 },
  { id: "REVO", name: "Honda Revo X", category: "Cub", price: 17_800_000 },
  { id: "CB150X", name: "Honda CB150X", category: "Sport Adventure", price: 36_500_000 },
];

// ── Koordinat awal peta (Pangkalpinang) ──────────────────────────────────────
export const HOME_COORD = { lat: -2.1316, lng: 106.1169 };

// ── Helper: format harga Rupiah ───────────────────────────────────────────────
export const formatRupiah = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(n);
